/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Transcript_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading the conversation…" |
*
* @param {Practice_Transcript_LoadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_transcript_loading = /** @type {((inputs?: Practice_Transcript_LoadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Transcript_LoadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Het gesprek wordt geladen…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement de l'entretien…")
	return /** @type {LocalizedString} */ ("Loading the conversation…")
});